import { Locales } from 'src/i18n'
import EventTranslationJson from './interfaces/EventTranslationJson'
import Translation from '../shared/interfaces/Translation'

export default class EventTranslation implements Translation {
  locale: Locales
  name: string

  constructor(locale: Locales, name: string) {
    this.locale = locale
    this.name = name
  }

  static fromJson(data: EventTranslationJson) {
    return new this(data.locale, data.name)
  }

  toJson(): EventTranslationJson {
    return {
      locale: this.locale,
      name: this.name,
    }
  }
}
